/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {
  cannotAccessList,
  defaultPage
} from '@/assets/cannotAccessList';
import TokenMixin from '@/mixins/TokenMixin'
import Validator from '@/prototype/Validator'
import Error from '@/views/Error.vue';

Vue.use(VueRouter);
Vue.mixin(TokenMixin)
Vue.use(Validator)
const vm = new Vue();

const routes = [{
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      title: 'Login',
      skipAuth: true,
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/pages/admin/Home.vue'),
    meta: {
      layout: 'content',
      title: 'Home',
      requireAuth: true,
      cannotAccess: cannotAccessList['Home'],
    },
  },
  {
    path: '/3d-printing-service',
    name: 'PrintingService',
    component: () => import('@/views/pages/admin/PrintingService.vue'),
    meta: {
      layout: 'content',
      title: '3D Printing Service',
      requireAuth: true,
      cannotAccess: cannotAccessList['PrintingService'],
    },
  },
  {
    path: '/3d-printing-materials',
    name: 'PrintingMaterials',
    component: () => import('@/views/pages/admin/PrintingMaterials.vue'),
    meta: {
      layout: 'content',
      title: '3D Printing Materials',
      requireAuth: true,
      cannotAccess: cannotAccessList['PrintingMaterials'],
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/pages/admin/About.vue'),
    meta: {
      layout: 'content',
      title: 'About Us',
      requireAuth: true,
      cannotAccess: cannotAccessList['About'],
    },
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: () => import('@/views/pages/admin/Subscription.vue'),
    meta: {
      layout: 'content',
      title: 'Subscription Form',
      requireAuth: true,
      cannotAccess: cannotAccessList['Subscription'],
    },
  },
  {
    path: '/news',
    name: 'NewsList',
    component: () => import('@/views/pages/admin/News.vue'),
    meta: {
      layout: 'content',
      title: 'News',
      requireAuth: true,
      cannotAccess: cannotAccessList['NewsList'],
    },
  },
  {
    path: '/news/create',
    name: 'CreateNews',
    component: () => import('@/views/pages/admin/NewsDetails.vue'),
    meta: {
      layout: 'content',
      title: 'Create News',
      requireAuth: true,
      cannotAccess: cannotAccessList['CreateNews'],
    },
  },
  {
    path: '/news/details/:id',
    name: 'NewsDetails',
    component: () => import('@/views/pages/admin/NewsDetails.vue'),
    meta: {
      layout: 'content',
      title: 'News Details',
      requireAuth: true,
      cannotAccess: cannotAccessList['NewsDetails'],
    },
  },
  {
    path: '*',
    name: 'Error',
    component: Error,
    meta: { title: 'Error' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('toggleLoadingPage', false);
  store.dispatch('setLoading', false);
  window.scrollTo(0, 0);

   if (to.meta.requireAuth) {
    const userData = vm.getCurrentUserData();
    const isUserLogin = vm.$validate.DataValid(userData);

    if (isUserLogin) {
      if (to.meta.cannotAccess && to.meta.cannotAccess.includes(userData.user_type)) {
        next(defaultPage[userData.user_type]);
      } else {
        next();
      }
    } else {
      next('/login');
    }
  } else if (to.meta.skipAuth) {
    const userData = vm.getCurrentUserData();
    if (vm.$validate.DataValid(userData) && userData.user_type) {
      if (to.name === 'login' || to.meta.cannotAccess && to.meta.cannotAccess.includes(userData.user_type)) {
        next(defaultPage[userData.user_type]);
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
})

const DEFAULT_TITLE = 'InLab CMS'

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = (`${to.meta.title} - ` || '') + DEFAULT_TITLE
  })
})

export default router
